/**
 * How the drawer, the (i) card and the artifact pages tell a voice that is not a
 * workshop: the opinion kind is synthetic, the party kind a documented position
 * (specs/kuutio-agents/README.md). Locale keys only; a kind without an entry
 * (kuutio, the room's own voice) shows no tag.
 */
export const AGENT_KIND_TAG = { opinion: 'chatAgent.agentSynthetic', party: 'chatAgent.agentDocumented' };
export const AGENT_KIND_INFO = { opinion: 'chatAgent.agentInfoOpinion', party: 'chatAgent.agentInfoParty' };
export const AGENT_KIND_DISCLAIMER = { opinion: 'chatAgent.agentInfoDisclaimerOpinion', party: 'chatAgent.agentInfoDisclaimerParty' };

/** The locale key of the tag beside a voice of this kind, or null. */
export const agentKindTag = (kind) => AGENT_KIND_TAG[kind] || null;
